import { useRef } from "react";
import { useInView } from "framer-motion";

export default function RedactedText({ children }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <span ref={ref} className="relative -mx-1 inline-block px-1 align-baseline">
      <span
        className={`relative z-10 transition-colors duration-700 ${
          inView ? "text-inherit" : "text-transparent"
        }`}
      >
        {children}
      </span>
      <span
        aria-hidden="true"
        className={`absolute inset-0 z-20 bg-navy transition-transform delay-500 duration-700 ease-out ${
          inView ? "scale-x-0" : "scale-x-100"
        }`}
        style={{ transformOrigin: "right" }}
      />
    </span>
  );
}
